import React from 'react';
import { BrowserRouter as Router} from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import Home from './components/Home';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import NavBar from './components/NavBar';

function App() {
  return (
    <Router>
      <GlobalStyles />
      <NavBar />
      <div className="App">
      <div id="home">
        <Home />
      </div>
      <div id="about">
        <About />
      </div>
      <div id="skills">
        <Skills />
      </div>
      <div id="experience">
        <Experience />
      </div>
      <div id="projects">
        <Projects />
      </div>
      <div id="testimonials">
        <Testimonials />
      </div>
      <div id="contact">
        <Contact />
      </div>

      </div>
    </Router>
  );
}


export default App;
